;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.pennylane.inbox', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider', '$urlRouterProvider']

  /**
   * Inbox des factures d'achat reçues via Pennylane (direction `supplier`),
   * synchronisées depuis le backend-pennylane. Pattern calqué sur les states
   * de liste de l'app (pagination résolue + vues main/toolbar), en version
   * allégée : pas de FilterSidebar/ColumnService (liste simple, pagination
   * côté client — le backend renvoie un tableau brut non paginé).
   */
  function RouteConfigurator ($stateProvider, $urlRouterProvider) {
    var listState = {
      name: 'pennylane-inbox',
      url: '/supplierinvoice',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'Factures fournisseurs',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('pennylaneInboxList')
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/pennylane/inbox/templates/pennylane-inbox-list.template.html',
          controller: 'PennylaneInboxListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/pennylane/inbox/templates/pennylane-inbox-toolbar.template.html',
          controller: 'PennylaneInboxToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Factures fournisseurs'
      }
    }

    $stateProvider.state(listState)

    // Ancienne URL de l'inbox : redirection (sinon les favoris tomberaient
    // silencieusement sur la route par défaut /invoice/list).
    $urlRouterProvider.when('/pennylane/inbox', '/supplierinvoice')
  }
})(window.angular)
